import { render, staticRenderFns } from "./product.page.vue?vue&type=template&id=24dc2453&scoped=true"
import script from "./product.page.vue?vue&type=script&lang=js"
export * from "./product.page.vue?vue&type=script&lang=js"
import style0 from "./product.page.vue?vue&type=style&index=0&id=24dc2453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc2453",
  null
  
)

export default component.exports